/* eslint-disable @typescript-eslint/no-explicit-any */
import { APP_LANG, LocalStorageKey } from "@/constants/constants";
import { NetFront } from "@/constants/netEvent";
import { useUrlStorage } from "@/hooks/useUrlStorage";
import { getToken } from "@/lib/apiUtils";
import { getLocalStorageItem, setLocalStorageItem } from "@/lib/localStorage";
import { dealString } from "@/lib/utils";
// import { useUrlStorage } from "@/hooks/useUrlStorage";
import { reqGet, reqPost } from "@/service/clientRequest";
import { configStore } from "@/stores/configStore";
import { sysConfigStore } from "@/stores/sysConfigStore";
import { GameComponentType } from "@/types/compontent/base/baseType";
import { GetActivityConfigType } from "@/types/swagger/activity";
import {
  GetComponentListRsp,
  GetComponentReq,
  GetConfigVersionReq,
  GetConfigVersionRsp,
  GetFrontCfgV2Req,
  GetFrontCfgV2Rsp,
  GetGameListRsp,
  GetPageRsp,
  GetSysConfigRsp,
} from "@/types/swagger/front";
import { NullReq } from "@/types/swagger/userwealth";

export const getFrontCfg = () => {
  const params: GetFrontCfgV2Req = {
    keys: "",
    tags: "h5",
  };
  return reqGet<GetFrontCfgV2Req, GetFrontCfgV2Rsp>(
    params,
    NetFront.mod,
    NetFront.GetFrontCfgV2,
    false,
  );
};

export const postGetPage = async () => {
  const startTime = new Date().getTime();
  const pageConfig = await reqPost<NullReq, GetPageRsp>(
    {
      keys: ["home", "casino"],
    },
    NetFront.mod,
    NetFront.GetPage,
  );
  const endTime = new Date().getTime();

  console.log("⏰ postGetPage 请求耗时：", endTime - startTime + "ms");
  // console.log(
  //   "获取页面配置 [postGetPage]-------> pageConfig key: 'home'",
  //   pageConfig.list[0].components,
  // );
  // console.log(
  //   "获取页面配置 [postGetPage]-------> pageConfig key: 'casino'",
  //   pageConfig.list[1].components,
  // );

  return pageConfig;
};

export const getGetConfigVersion = async () => {
  const configVersion = await reqGet<NullReq, GetConfigVersionRsp>(
    {},
    NetFront.mod,
    NetFront.GetConfigVersion,
  );
  return configVersion;
};

export const initConfig = async () => {
  const [configVersion, pageConfig] = await Promise.all([
    getGetConfigVersion(),
    postGetPage(),
  ]);
  return {
    configVersion,
    pageConfig,
  };
};

export const GetPromoFeedDataNew = () => {
  return reqGet<{}, GetActivityConfigType>(
    {},
    NetFront.mod,
    "NA.GetActivityConfig ",
    false,
  );
};

export const getConfigVersion = async () => {
  const { getStoredParams, getParamByKey } = useUrlStorage();
  const ch = getParamByKey("ch") || "0";
  const ic = getParamByKey("ic") || "";
  const url = new URL(getStoredParams().url || window.location.href);

  const configVersionHistory = getLocalStorageItem(
    LocalStorageKey.ConfigVersionHistory,
    {} as Record<string, unknown>,
  );
  const time = new Date().getTime();

  const params: GetConfigVersionReq = {
    pack: ch || String(configStore.configVersion?.pack_no) || "",
    ic: ic || configStore.configVersion?.ic || "",
    host: url.host,
    v: configStore.configVersion?.version || "",
    ad_install_referer:
      dealString(sysConfigStore.sdkData?.adjust?.ad_install_referer) || "",
    ad_deep_link_referer:
      dealString(sysConfigStore.sdkData?.adjust?.ad_deeplink_referer) || "",
    fb_deep_link_referer:
      dealString(sysConfigStore.sdkData?.facebook?.fb_deep_link_referer) || "",
    deep_link: dealString(sysConfigStore.sdkData?.deeplink) || "",
    play_install_referer: dealString(sysConfigStore.sdkData?.playinstall) || "",
  } as GetConfigVersionReq;

  const res = await reqPost<GetConfigVersionReq, GetConfigVersionRsp>(
    params,
    NetFront.mod,
    NetFront.GetConfigVersion,
    false,
  );
  configVersionHistory[time] = {
    req_pack_no: params.pack,
    stored_url: getStoredParams().url,
    token: getToken(),
    req_version: params.v,
    url: url.toString(),
    href: window.location.href,
    [`res_${time}`]: { pack_no: res?.pack_no, version: res?.version },
  };

  // 如果历史记录超过5个，删除最旧的一个
  const historyKeys = Object.keys(configVersionHistory);
  if (historyKeys.length > 5) {
    // 按时间戳排序，删除最旧的
    const sortedKeys = historyKeys.sort((a, b) => Number(a) - Number(b));
    const oldestKey = sortedKeys[0];
    delete configVersionHistory[oldestKey];
  }

  setLocalStorageItem(
    LocalStorageKey.ConfigVersionHistory,
    configVersionHistory,
  );
  return res;
};

interface paramsType {
  maker_tag?: string;
  gclass?: number | string;
  page?: number;
  page_size?: number;
  sort?: string;
  tag?: number | string;
}
export const reqGetGameList = async (queryParams?: paramsType) => {
  const reqStartTime = new Date().getTime();

  const gameListData = await reqGet<NullReq, GetGameListRsp>(
    {
      page_size: 100000,
      // v: "nodejs-" + new Date().toISOString(),
      ...queryParams,
    },
    NetFront.mod,
    NetFront.GetGameList,
    false,
    undefined,
    undefined,
    {
      ttl: 1000 * 60 * 60,
      forceRefresh: false,
    },
  );

  const reqEndTime = new Date().getTime();
  if (reqEndTime - reqStartTime > 2000) {
    console.log("nodejsReq GetGameList m=", reqStartTime);
  }

  if (!gameListData?.list) {
    console.log("[reqGetGameList] Error: No list in response", gameListData);
  }
  return gameListData;
};

export const getSysConfig = async () => {
  const sysData = await reqGet<NullReq, GetSysConfigRsp>(
    {},
    NetFront.mod,
    NetFront.GetSysConfig,
    false,
  );
  if (!sysData) {
    // console.log("GetSysConfig error", sysData);
  }
  return sysData;
};

export const getCloudflareValidation = async (params: { token: string }) => {
  return reqPost<{ token: string }, { is_success: boolean }>(
    params,
    NetFront.mod,
    NetFront.GetCloudflareValidation,
    false,
  );
};

export const getComponentList = async (params: { gkeys: string }) => {
  return reqGet<NullReq, GetComponentListRsp>(
    params,
    NetFront.mod,
    NetFront.GetComponentList,
    false,
  );
};

export const getComponent = async (params: { key: string }) => {
  return reqGet<GetComponentReq, GameComponentType>(
    params,
    NetFront.mod,
    NetFront.GetComponent,
    false,
  );
};
export const useSaveSubscription = async (params: any) => {
  return await reqPost<any, NullReq>(
    params,
    NetFront.mod,
    NetFront.SaveSubscription,
    true,
  );
};
